import { __assign } from "tslib";
function memo() {
    var hasCache = false;
    var result;
    return function (target, propertyKey) {
        if (typeof target[propertyKey] !== 'function') {
            throw new Error('memo() must be decorated on one of function properties of target');
        }
        Object.defineProperty(target, propertyKey, __assign(__assign({}, Object.getOwnPropertyDescriptor(target, propertyKey)), { value: function () {
                if (!hasCache) {
                    result = target[propertyKey]();
                    hasCache = true;
                }
                return result;
            } }));
    };
}
export default memo;
//# sourceMappingURL=memo.js.map